import classNames from '@/utils/classNames';
import type { LabelHTMLAttributes } from 'react';
import type { FCC } from 'react-fc';
import styles from './CheckboxLabel.module.css';

/**
 * Can also be used for Radio buttons
 */
export const CheckboxLabel: FCC<LabelHTMLAttributes<HTMLLabelElement> & { span?: boolean; padded?: boolean }> = ({
    children,
    className,
    span,
    padded,
    ...rest
}) => {
    const props = { className: classNames(styles.label, { [styles.padded]: padded }, className), ...rest };
    if (span) {
        return <span {...props}>{children}</span>;
    }
    return <label {...props}>{children}</label>;
};
